import Handlebars from 'handlebars';

export const templateStr = (template: string, valueObj: { [key: string]: any }) => {
  let content = template || '';
  try {
    const applyValueToTemplate = Handlebars.compile(template, { noEscape: true });
    content = applyValueToTemplate(valueObj);
    content = content.replace(/\.en\.en/g, '.en ');
  } catch (err) {
    console.log(err);
  }
  return content;
};

export const templateStrFunc = (valueObj: { [key: string]: any }) => (template?: string | null) => templateStr(template || '', valueObj);

export const templateStrForStructuredData = (template: any, variables: { [key: string]: any }) => {
  const isArray = Array.isArray(template);
  const newTemplateStr = {} as any;
  Object.keys(template).forEach((key) => {
    const templateData = template[key];
    if ((key === 'sameAs' || key === 'availableLanguage') && Array.isArray(templateData)) {
      newTemplateStr[key] = templateData.map((value) => templateStr(value, variables));
    } else if (key === 'additionalProperty' && Array.isArray(templateData)) {
      newTemplateStr[key] = templateData.map((propObj) => ({
        ...propObj,
        value: templateStr(propObj.value, variables),
        propertyID: templateStr(propObj.propertyID, variables),
      }));
    } else if (typeof templateData === 'string') {
      if (isArray) {
        newTemplateStr.push(templateStr(templateData, variables));
      } else {
        newTemplateStr[key] = templateStr(templateData, variables);
      }
    } else if (Array.isArray(templateData) && key === 'contactPoint') {
      newTemplateStr[key] = templateData.map((value) => templateStrForStructuredData(value, variables));
    } else if (typeof templateData === 'object') {
      let objCache = {} as any;
      if (key === 'brand') {
        objCache = {
          name: templateStr(templateData.name, variables),
        };
      }
      if (key === 'offers') {
        objCache = {
          lowPrice: templateStr(templateData.lowPrice, variables),
          highPrice: templateStr(templateData.highPrice, variables),
          offerCount: templateStr(templateData.offerCount, variables),
          priceCurrency: templateStr(templateData.priceCurrency, variables),
        };
      }
      if (isArray) {
        newTemplateStr.push(templateData);
      } else {
        newTemplateStr[key] = {
          ...templateData,
          ...objCache,
        };
      }
    } else {
      newTemplateStr[key] = templateData;
    }
  });

  return newTemplateStr;
};
